<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  components: {},
  name: "App",
};
</script>

<style>
#app {
  width: 100%;
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue